<div class="table-view-list">
    <div class="top-row-container">
        <div class="add-new-button">
            <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'plus'"
                [label]="'texturesList.button.new' | translate"
                (clickEmitter)="openAddTextureDialog($event)"
            ></app-button>
        </div>
    </div>

    <table mat-table [dataSource]="currentTextures" class="mat-elevation-z0" matSort
           (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "texturesList.column.id" | translate }}</th>
            <td mat-cell *matCellDef="let texture"> {{ texture.id }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "texturesList.column.name" | translate }}</th>
            <td mat-cell *matCellDef="let texture"> {{ texture.name }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ "texturesList.column.action" | translate }}</th>
            <td mat-cell *matCellDef="let texture">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'texturesList.tooltips.delete' | translate"
                            (click)="deleteTexture($event, texture)">
                        <mat-icon class="icon">delete_outline</mat-icon>
                    </button>

                    <button mat-button
                            class="table-button"
                            [matTooltip]="'texturesList.tooltips.editJson' | translate"
                            (click)="openEditTextureJsonDialog($event, texture)">
                        <mat-icon class="icon">data_object</mat-icon>
                    </button>

                    <button mat-button
                            class="table-button"
                            [matTooltip]="'texturesList.tooltips.editForm' | translate"
                            (click)="openEditTextureFormDialog(texture)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>

                    <button mat-button
                            class="table-button"
                            [matTooltip]="'texturesList.tooltips.upload' | translate"
                            (click)="fileInput.click()">
                        <input #fileInput type="file" class="file-upload" hidden
                               (change)="uploadTexture($event, texture)">
                        <mat-icon class="icon">upload_file</mat-icon>
                    </button>

                    @if (texture.asset) {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'texturesList.tooltips.view' | translate"
                                (click)="openAsset(texture.asset)">
                            <mat-icon class="icon">image</mat-icon>
                        </button>
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsTextures"></tr>
        <tr mat-row *matRowDef="let texture; columns: displayedColumnsTextures;"></tr>
    </table>
</div>

